import { useApiClient } from '@/composables/useApiClient'

export default defineNuxtPlugin(() => {
  const axios = useApiClient()

  return {
    provide: {
      axios,
    },
  }
})
